module.exports = __webpack_public_path__ + "img/food-potato.621bd964.svg";